export default {
  elevation1: {
    boxShadow: '0px 2px 5px 1px #0000001A',
    border: '1px solid #EEEEEE'
  }
};
